module.exports = __webpack_public_path__ + "static/media/Nettoken template.b6cb8974.xls";